<template>
  <v-card flat>
    <!-- Apprentice start -->
    <template v-if="employee.apprentice || $route.name == 'CompanyApprentice'">
      <div class="title-icon">
        <h4>{{ $t("labels.workplaces") }}</h4>
        <v-icon v-if="isEditable" @click="openLinkWorkplace = true">$sl-link</v-icon>
      </div>

      <workplaces-list
        v-if="employee.workplaces && employee.workplaces.length"
        :workplaces="employee.workplaces"
        @item-click="showDeleteModal"
        actionType="unlink"
        :withSearch="false"
        :isEditable="isEditable"
      ></workplaces-list>

      <div class="title-icon mt-8">
        <h4>{{ $t("labels.instructors") }}</h4>
        <v-icon v-if="isAdmin($route.params.id) || isCompanyEducationResponsible($route.params.id)" @click="openLinkInstructor = true"
          >$sl-link</v-icon
        >
      </div>

      <v-card v-if="employee.instructors && employee.instructors.length">
        <v-list two-line class="graylist ma-0 pa-0">
          <template v-for="(item, index) in employee.instructors.filter(Boolean)">
            <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
            <v-list-item :key="`item-${index}`">
              <v-list-item-content>
                <v-list-item-title v-if="item && item.employed"
                  >{{ item.employed.firstName }}
                  {{ item.employed.lastName }}</v-list-item-title
                >
                <v-list-item-subtitle
                  v-if="item && item.employed && item.employed.tradeCertificates"
                  >{{
                    item.employed.tradeCertificates
                      .map((o) => o.profession.name)
                      .join(", ")
                  }}</v-list-item-subtitle
                >
              </v-list-item-content>
            
              <v-list-item-action
                v-if="canEdit(item)"
                @click.prevent="unLinkInstructor(item.id)"
              >
                <v-icon class>$sl-unlink</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
      <template v-if="hasQualificationTime==true">
        <div class="title-icon mt-8">
          <h4>{{ $t("labels.apprentice") }}</h4>
        </div>

          <ActionButton
            actionIcon="$sl-stairs-ascend"
            type="application"
            @click="goToQualifyingTime"
            :isDisabled="isImitatingUser()"
          >
            <v-badge v-if="qualificationTimeNotice > 0" color="red" :value="qualificationTimeNotice">
              <template v-slot:badge>{{ qualificationTimeNotice }}</template>
              {{ $t("labels.qualifying-time") }}  
            </v-badge>
            <template v-else>
              {{ $t("labels.qualifying-time") }}  
            </template>
          </ActionButton>

        <h4 class="mt-10">{{ $t("labels.employment-rate") }}</h4>
        <p class="pt-2"> {{ $t("labels.employment-rate-explanation") }}</p>
        <QualificationTimeModificationList :studentName="employee.firstName" :educationId="employee.educations[0].id" @openModal="openModal" :key="renderKey"></QualificationTimeModificationList>
        <div style="margin-top:20px;">&nbsp;</div>
        <ActionButton
          actionIcon="$sl-stairs-ascend"
          type="application"
          @click="showEmpRate=true"
          :isDisabled="isImitatingUser()"
          >{{ $t("labels.change-employment-rate") }}</ActionButton
        >
      </template>
    </template>

    <!-- Employee start -->
    <template v-else>
      <div class="title-icon">
        <h4>{{ $t("labels.apprentices") }}</h4>
        <!-- <v-icon @click="linkApprentice(1)">$sl-link</v-icon> -->
      </div>
      <MessageBox class="mt-0 mb-7" type="alert" v-if="employee.apprentices.length>2">        
        <h5>{{ $t('company.mb-max-apprentice-title') }}</h5>
        <p v-html="$t('company.mb-max-apprentice-text')"></p>        
      </MessageBox>
      <v-expansion-panels class="mt-4 certificate">
        <v-expansion-panel
          v-for="(item) in employee.apprentices"
          :key="item.id"
          :aria-label="item.apprentice.firstName || ''"
        >
          <v-expansion-panel-header expand-icon="$sl-arrow-down">
            <div>
              <div class="header-title">
                {{ item.apprentice.firstName || '' }} {{ item.apprentice.lastName || '' }}
              </div>
              <div class="header-sub-title gray" v-if="item.professionId && item.professionId">
               {{ getProfessionNameById(item.professionId)}}
              </div>
              <div class="header-sub-title gray" v-else-if="item.profession && item.profession.name">
               {{ item.profession.name}}
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>

          <ActionButton
          :isDisabled="!isAdmin($route.params.id) || isImitatingUser()"
          type="application"
          class="mt-4 mb-2"
          actionIcon="$sl-unlink"
          @click="unLinkApprentice(item)"
          >{{ $t("company.unlink") }}</ActionButton
        >
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <ActionButton
          :isDisabled="!isAdmin($route.params.id) || isImitatingUser()"
          type="application"
          class="mt-n3 mb-5"
          actionIcon="$sl-link"
          @click="openLinkApprentice=true"
          >{{ $t("company.link-apprentice") }}</ActionButton
      >
      
      <template
        v-if="
          hasDepartments($route.params.id) &&
          (isAdministrator || isDepartmentAdministrator($route.params.id))
        "
      >
        <h4 class="mt-8">{{ $t("company.roles") }}</h4>
        <p>{{ $t("company.department-subtitle") }}</p>
        <ActionButton
          type="application"
          class="mt-4 mb-2"
          :isDisabled="!isImitatingUser()"
          @click="
            $nextTick(() => {
              $router.push({
                name: 'CompanyEmployeePermissions',
                params: { id: $route.params.id, employee_id: $route.params.employee_id },
              });
            })
          "
          actionIcon="$sl-user"
          >{{ $t("labels.show-person-role") }}</ActionButton
        >
      </template>
      <template v-if="hasDepartments($route.params.id) && isAdminUser($route.params.id)">
        <template v-if="empDeps.instructor_deps && empDeps.instructor_deps.length > 0">
          <h6 class="mt-8 text-uppercase">{{ $t("labels.instructor") }}</h6>
          <p>{{ $t("company.instructor-subtitle", { fullname: fullname }) }}</p>
          <ListItems
            :items="empDeps.instructor_deps"
            :isEditable="isAdmin($route.params.id)"
            @clickedDepartment="clickedDepartment"
          ></ListItems>
        </template>
        <template
          v-if="
            empDeps.companyEducationResponsible_deps &&
            empDeps.companyEducationResponsible_deps.length > 0
          "
        >
          <h6 class="mt-8 text-uppercase">{{ $t("labels.yua") }}</h6>
          <p>{{ $t("company.yua-subtitle", { fullname: fullname }) }}</p>
          <ListItems
            :items="empDeps.companyEducationResponsible_deps"
            :isEditable="isAdmin($route.params.id)"
            @clickedDepartment="clickedDepartment"
          ></ListItems>
        </template>
        <template
          v-if="
            empDeps.distanceEducationAdministrator_deps &&
            empDeps.distanceEducationAdministrator_deps.length > 0
          "
        >
          <h6 class="mt-8 text-uppercase">{{ $t("roles.gb") }}</h6>
          <p>{{ $t("company.distance-subtitle", { fullname: fullname }) }}</p>
          <ListItems
            :items="empDeps.distanceEducationAdministrator_deps"
            :isEditable="isAdmin($route.params.id)"
            @clickedDepartment="clickedDepartment"
          ></ListItems>
        </template>
        <template
          v-if="
            empDeps.departmentAdministrator_deps &&
            empDeps.departmentAdministrator_deps.length > 0
          "
        >
          <h6 class="mt-8 text-uppercase">{{ $t("roles.dep-admin2") }}</h6>
          <p>{{ $t("company.depadmin-subtitle", { fullname: fullname }) }}</p>
          <ListItems
            :items="empDeps.departmentAdministrator_deps"
            :isEditable="isAdmin($route.params.id)"
            @clickedDepartment="clickedDepartment"
          ></ListItems>
        </template>
        <template
          v-if="isAdministrator && employee.isAdministrator"
        >
          <h6 class="mt-8 text-uppercase">{{ $t("roles.admin") }}</h6>
          <p>{{ $t("company.admin-subtitle", { fullname: fullname }) }}</p>
          <ListItems
            :items="departments"
            :isEditable="isAdmin($route.params.id)"
            @clickedDepartment="clickedDepartment"
          ></ListItems>
        </template>
      </template>
    </template>

    <!-- <ActionButton :isDisabled="!isEditable" class="mt-10" @click="save()" actionIcon="$sl-save">{{$t('labels.save')}}</ActionButton> -->
    <LinkWorkplaceModal
      :showModal="openLinkWorkplace"
      :isEditable="isEditable"
      :linkedWp="employee.workplaces"
      @linked="linkWorkplace"
      :title="$t('labels.link-workplace')"
      @close="openLinkWorkplace = false"
    />
    <LinkInstructorModal
      v-if="employee && employee.apprentice && isAdminUser($route.params.id)"
      :show="openLinkInstructor"
      :isEditable="isEditable"
      :isQualificationTime="employee.type == 'QualificationTime' ? true : false"
      :linkedInstructors="employee.instructors ? employee.instructors : []"
      :machineIds="machineIds"
      :apprenticeProfession="employee.professionId ? employee.professionId : null"
      @linked="linkInstructor"
      @close="openLinkInstructor = false"
    />
  <v-dialog v-model="openLinkApprentice" max-width="700px" persistent>
    <LinkApprenticeModal               
      :linkedApprentices="employee.apprentices ? employee.apprentices : []"
      :employee="employee"
      @linked="linkApprentice"
      @close="openLinkApprentice = false"
    />
  </v-dialog>
    <ModalBase
        :show="showModal"
        maxWidth="400px"
        :title="$t('labels.unlink-workplace')"
        cancelIcon="$sl-cancel"
        submitIcon="$sl-unlink"
        :cancelText="$t('labels.cancel')"
        :submitText="$t('labels.unlink')"
        @close="closeModal"
        @cancel="closeModal"
        @submit="unLinkWorkplace"
        :outlinedCancel="false">
    </ModalBase>
    <v-dialog v-model="showEmpRate" v-if="employee.apprentice" max-width="360px" persistent>
      <CompanyEmployeeRateModal :shown="showEmpRate" :employee = "employee" :qualificationTimeModification = "this.qualificationTimeModification" @close="hideModal"></CompanyEmployeeRateModal>
    </v-dialog>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import MessageBox from '@/components/Common/MessageBox.vue'
import ActionButton from "@/components/Common/ActionButton";
import ListItems from "@/components/Common/ListItems";
import WorkplacesList from "@/components/Common/Workplace/WorkplacesList";
import LinkWorkplaceModal from "@/components/Company/LinkWorkplaceModal";
import LinkInstructorModal from "@/components/Company/LinkInstructorModal";
import LinkApprenticeModal from "@/components/Company/LinkApprenticeModal";
import CompanyEmployeeRateModal from "@/components/Company/CompanyEmployeeRateModal";
import QualificationTimeModificationList from "@/components/Common/QualifyingTime/QualificationTimeModificationList";
import { RulesMixin, CompanyRoles } from "@/components/mixins";
import { mapGetters } from "vuex";
import findIndex from "lodash/findIndex";
import find from "lodash/find";
import uniqBy from "lodash/uniqBy";
import compact from "lodash/compact";
import ModalBaseMixin from "@/components/mixins/ModalBaseMixin";
import ModalBase from '@/components/Common/ModalBase';
import get from 'lodash/get'
import orderBy from "lodash/orderBy";

// @group Company
// CompanyEmployeeWorkplace component
export default {
  name: "CompanyEmployeeWorkplace",

  mixins: [RulesMixin, CompanyRoles, ModalBaseMixin],

  props: {
    // employee object
    emp: {
      // `Object`
      type: Object,
    },
    // Should fields be editable
    isEditable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true,
    },

    // get a notification if QT is ready for approval
    qualificationTimeNotice: {
      type: [Number, String],
      default: 0
    }
  },

  components: {
    ActionButton,
    MessageBox,
    CompanyEmployeeRateModal,
    LinkWorkplaceModal,
    LinkInstructorModal,
    WorkplacesList,
    ListItems,
    LinkApprenticeModal,
    ModalBase,
    QualificationTimeModificationList
  },
  watch: {
    emp() {
      this.init();
    },
  },
  data: () => ({
    employee: null,
    empDeps: {},
    fullname: "",
    departments: [],
    openLinkApprentice: false,
    showEmpRate: false,
    openLinkWorkplace: false,
    openLinkInstructor: false,
    qualificationTimeModification: null,
    renderKey: 0
  }),

  mounted() {
    this.$scrollToTop();
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("basic", ["getProfessionById", "getProfessionNameById"]),
    ...mapGetters("currentuser", [
      "currentUser",
      "isCompanyUser",
      "isApprentice",
      "isAdminUser",
      "isAdministrator",
      "isDepartmentAdministrator",
      "isCompanyEducationResponsible",
      "isAdmin",
      "isImitatingUser",
    ]),
    hasQualificationTime(){
      return Boolean(get(this,'employee.educations', []).find( e=> e.basicEducationCertificate!=null))
    },

    machineIds(){
      if(this.emp.professionId && this.emp.educations)
      {
        let found = orderBy(this.emp.educations, ['endDate'], ['desc']).find(e => e.professionId== this.emp.professionId)
        if(found && found.educationProfessionOrientations){
          return found.educationProfessionOrientations.map((o) => {
            if(o.professionMachineOrientation && o.professionMachineOrientation.machineId){
              return o.professionMachineOrientation.machineId
            }            
          })
        } return []
      }
    }

  },
  methods: {
    openModal(qtm) {
      this.showEmpRate = true
      this.qualificationTimeModification = qtm
    },

    hideModal() {
      this.showEmpRate = false
      this.qualificationTimeModification = null
      this.renderKey += 1
    },

    init() { 
      this.employee = this.emp
      if(this.isAdministrator){
        this.getDepartments()
      }
      //Need this to call haveCertificates in component LinkApprenticeModal
      this.employee.employed = this.employee
      if (
        this.emp &&
        this.emp.id &&
        this.emp.departmentEmployments &&
        this.hasDepartments(this.$route.params.id)
      ) {
        this.getEmployeeById(this.emp.id);
      }
    },
    canEdit(instructor){
      if(this.isAdministrator){
        return true
      }
      else if(this.isDepartmentAdministrator(this.$route.params.id) || this.isCompanyEducationResponsible(this.$route.params.id)){
        if(this.hasDepartments(this.$route.params.id)==true){
            return this.isSameDepartment(instructor.departmentEmployments, this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator, false), this.hasDepartments(this.$route.params.id))
        }else {
          return true
        }
      }
      else{
        return false
      }
    },
    clickedDepartment(params) {
      this.$nextTick(() => {
        this.$router.push({
          name: "CompanyEmployees",
          params: { id: this.$route.params.id, tab: 1, search: params.departmentName },
        });
      });
    },
    /**
     * @vuese
     * Used to link the instructor
     * @arg called in an object representing instructor object
     */
    linkInstructor(i) {
      this.openLinkInstructor = false;

      if (i.length === 0) {
        this.$events.fire("showError", this.$t("errors.apprentice"));
        return;
      }
      this.employee.instructors = i;
      let data = {
        instructorIds: this.employee.instructors.map((o) => o.id),
        workplaces: this.employee.workplaces,
      };

      this.save(data);
    },
    /**
     * @vuese
     * Used to unlink the instructor
     * @arg called in an object representing instructor object
     */
    unLinkInstructor(i) {
      if (this.employee.instructors.length < 2) {
        this.$events.fire("showError", this.$t("errors.apprentice"));
        return;
      }
      let idx = findIndex(this.employee.instructors, ["id", i]);

      if (idx > -1) {
        this.employee.instructors.splice(idx, 1);
        let data = {
          instructorIds: this.employee.instructors.map((o) => o.id),
          workplaces: this.employee.workplaces,
        };
        this.save(data);
      }
    },
    /**
     * @vuese
     * Used to link the instructor
     * @arg called in an object representing instructor object
     */
    linkApprentice(data) {
      this.employee.apprentices = data.apprentices      
      this.save({apprenticeshipIds: data.ids});
      this.openLinkApprentice = false

    },
    /**
     * @vuese
     * Used to unlink the apprentice
     * @arg called in an object representing apprentice object
     */
    unLinkApprentice(item) {      
      let emps = []

      API.listEmployments(this.$route.params.id, { search: '', workplaceId: null, type: 'apprentice' })
        .then(res => {
          emps = res.data
          let found = emps.find( f => f.id==item.id)
          
          if(found && found.instructors)
          {
            if(found.instructors.length>1)
            {
              let idx = findIndex(this.employee.apprentices, ["id", item.id]);
              if (idx > -1) {
                this.employee.apprentices.splice(idx, 1);
                let data = {
                  apprenticeshipIds: this.employee.apprentices.map((o) => o.id),                  
                };
                this.save(data);

           //     this.$events.fire("showInfo", this.$t("success.saved"));
              }                
            }
            else
            {
              this.$events.fire("showError", this.$t("errors.apprentice"));
            }
          }        
        })
        .catch(err => {
          console.log(err)
        })                              
    },
    /**
     * @vuese
     * Used to unlink the instructor
     * @arg called in an object representing instructor object
     */
    linkWorkplace(wp) {
      this.openLinkWorkplace = false;
      this.employee.workplaces = wp;
      let data = {
        workplaces: this.employee.workplaces,
      };

      this.save(data);
    },
    /**
     * @vuese
     * Used to unlink the workplace
     * @arg called in an object representing workplace object
     */
    async unLinkWorkplace() {
      if (!this.isEditable) {
        return;
      }
      this.showModal=false

      let idx = findIndex(this.employee.workplaces, ["id", this.selectedItem.id]);
      if (idx > -1) {
        this.employee.workplaces.splice(idx, 1);
        this.save({ workplaces: this.employee.workplaces });
      }
    },
    /**
     * @vuese
     * Used to emit the values of instructors and workplaces
     */
    save(data) {
      if (!(this.employee && this.employee.id)) return;
      
      if (this.employee.apprentice) {
        API.updateApprenticeship(this.employee.id, { data: data })
          .then((response) => {
            this.$events.fire("showInfo", this.$t("success.saved"));
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));            
          });
      } else {      
        API.updateEmployment(this.employee.id, { data: data })
          .then((response) => { 
            this.$events.fire("showInfo", this.$t("success.saved"));                          
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));
            console.log("There was an error:", error);
          });
      }
    },

    /**
     * @vuese
     * Used to fetch Employee
     * @arg the argument is an integer representing Employee id
     */
    async getEmployeeById(id) { 
      API.getEmployee(id)
        .then((res) => { 
          this.fullname = res.data.employed.fullName;
          this.empDeps=this.getEmployeeRoles(res.data);
          //this.listDepartments()
          this.instructor_deps = [];
          this.departmentAdministrator_deps = [];
          this.companyEducationResponsible_deps = [];
          this.distanceEducationAdministrator_deps = [];

          res.data.departmentEmployments.forEach((o) => {
            if (o.isDepartmentInstructor == true) {
              this.instructor_deps.push({ name: o.department.name, id: o.departmentId });
            }
            if (o.isDepartmentEducationResponsible) {
              this.companyEducationResponsible_deps.push({
                name: o.department.name,
                id: o.departmentId,
              });
            }
            if (o.isDepartmentDistanceEducationAdministrator) {
              this.distanceEducationAdministrator_deps.push({
                name: o.department.name,
                id: o.departmentId,
              });
            }
            if (o.isDepartmentAdministrator) {
              this.departmentAdministrator_deps.push({
                name: o.department.name,
                id: o.departmentId,
              });
            }
          });
          
          const apprenticeships = uniqBy(compact(res.data.apprenticeshipInstructors.map(ai => ai.apprenticeship)), 'id')
          for (let i =0; i<this.instructor_deps.length; i++){
          
            this.instructor_deps[i].appCount=0
            apprenticeships.forEach(app => {
              app.workplaces.forEach(wp => {
                if(wp.workplaceaddress.departmentWorkplaces.find(dep => dep.departmentId==this.instructor_deps[i].id))
                {
                  this.instructor_deps[i].appCount++
                }
              });                
            });  
          }
          for (let i =0; i<this.instructor_deps.length; i++){
            this.instructor_deps[i].subTitle = this.$tc('company.apprentice-count', this.instructor_deps[i].appCount) + ' '+ this.$t('company.apprentice-count2', {fullname: this.fullname}) 
          }

          this.empDeps.instructor_deps = this.instructor_deps

        })
        .catch((error) => {
          console.log("There is no employee for this id: " + error);
        });
    },

    goToQualifyingTime() {
      this.$nextTick(() => {
        this.$router.push({
          name: "PersonQualifyingTime",
          params: { id: this.employee.personId },
        });
      });
    },
  getDepartments() {      
    API.listDepartments(this.$route.params.id)
      .then((response) => {
        response.data.forEach(r => {
          r.subTitle = ''
          if(r.apprenticeships && r.apprenticeships.length>0){
            r.subTitle += 'LÄR: ' + r.apprenticeships.length + "&nbsp;&nbsp;&nbsp;"
          }
          if(r.instructors && r.instructors.length>0){
            r.subTitle += 'HL: ' + r.instructors.length + "&nbsp;&nbsp;&nbsp;"
          }
          if(r.companyEducationResponsible && r.companyEducationResponsible.length>0){
            r.subTitle += 'YUA: ' + r.companyEducationResponsible.length + "&nbsp;&nbsp;&nbsp;"
          }
          if(r.distanceEducationAdministrators && r.distanceEducationAdministrators.length>0){
            r.subTitle += 'BG: ' + r.distanceEducationAdministrators.length + "&nbsp;&nbsp;&nbsp;"
          }
          if(r.administrators && r.administrators.length>0){
            r.subTitle += 'AVD: ' + r.administrators.length
          }
          this.departments.push(r)
        });                      
      })
      .catch((error) => {
        console.log("There was an error:", error);
      });
    },
  },
};
</script>
